import React, { useState } from 'react';
import { SearchIcon, Loader2Icon, LinkIcon } from 'lucide-react';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
import { extractAsin } from './utils';
interface AsinUrlFormProps {
  onImportComplete: () => void;
}
export const AsinUrlForm: React.FC<AsinUrlFormProps> = ({
  onImportComplete
}) => {
  const dk = useDarkClasses();
  const [input, setInput] = useState('');
  const [isFetching, setIsFetching] = useState(false);
  const [result, setResult] = useState<{
    asin: string;
    title: string;
    author: string;
  } | null>(null);
  const [error, setError] = useState('');
  const extractedAsin = extractAsin(input);
  const handleSearch = () => {
    if (!extractedAsin) {
      setError('Could not detect a valid ASIN from the input.');
      return;
    }
    setError('');
    setIsFetching(true);
    // Simulate API call
    setTimeout(() => {
      setResult({
        asin: extractedAsin,
        title: 'Imported Amazon Book',
        author: 'Author Name'
      });
      setIsFetching(false);
    }, 1500);
  };
  const handleAddToQueue = () => {
    onImportComplete();
    setInput('');
    setResult(null);
  };
  return <div className="space-y-6" data-id="element-17579" data-mp="sakyjhiivs8">
      <div data-id="element-17580" data-mp="4r9xap5kputp">
        <label className={`block text-sm font-medium mb-2 ${dk.textPrimary}`} data-id="element-17581" data-mp="4ri7286egk0o">
          Amazon URL or ASIN
        </label>
        <p className={`text-xs mb-3 ${dk.textSecondary}`} data-id="element-17582" data-mp="9sfr6qayzo4t">
          Paste a link to your book on Amazon, or just the 10-character ASIN.
        </p>
        <div className="relative" data-id="element-17583" data-mp="joshrfb7xlvc">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-17584" data-mp="jo0oib53g088">
            <LinkIcon className={`h-5 w-5 ${dk.textMuted}`} data-id="element-17585" data-mp="ogttn04h5aku" />
          </div>
          <input type="text" value={input} onChange={e => {
          setInput(e.target.value);
          setError('');
          setResult(null);
        }} placeholder="https://www.amazon.com/dp/B08XYZ1234" className={`w-full pl-10 p-3 rounded-lg border focus:ring-2 focus:ring-purple-500 focus:border-transparent ${dk.input}`} data-id="element-17586" data-mp="shvrbciqtekp" />
        </div>

        {extractedAsin && !result && !isFetching && <div className="mt-2 flex items-center gap-2" data-id="element-17587" data-mp="3887z2vik3abg">
            <span className={`text-xs ${dk.textSecondary}`} data-id="element-17588" data-mp="389ss2gp82l77">
              Detected ASIN:
            </span>
            <span className={`text-xs font-mono px-2 py-0.5 rounded bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300`} data-id="element-17589" data-mp="33fojxu48074j">
              {extractedAsin}
            </span>
          </div>}

        {error && <p className="mt-2 text-sm text-red-500" data-id="element-17590" data-mp="3r7ltfek76n2h">{error}</p>}
      </div>

      <button onClick={handleSearch} disabled={isFetching || !input.trim() || !extractedAsin} className={`flex items-center justify-center w-full sm:w-auto px-6 py-2.5 rounded-lg font-medium text-white transition-colors ${isFetching || !input.trim() || !extractedAsin ? 'bg-purple-400 cursor-not-allowed' : 'bg-purple-600 hover:bg-purple-700'}`} data-id="element-17591" data-mp="3m8ipxyjv8owm">
        {isFetching ? <>
            <Loader2Icon className="w-5 h-5 mr-2 animate-spin" data-id="element-17592" data-mp="cbjwqbd95t02" />
            Fetching metadata...
          </> : <>
            <SearchIcon className="w-5 h-5 mr-2" data-id="element-17593" data-mp="3tri9c47bugfz" />
            Look up ASIN
          </>}
      </button>

      {result && !isFetching && <div className={`mt-6 p-4 rounded-xl border ${dk.card} ${dk.border}`} data-id="element-17594" data-mp="3kqkf2dmoxnal">
          <h3 className={`font-bold mb-4 ${dk.textHeading}`} data-id="element-17595" data-mp="3pq6soo6fl5jx">Preview Result</h3>
          <div className={`flex items-center justify-between p-4 rounded-lg border ${dk.borderSubtle} ${dk.surfaceMuted} mb-6`} data-id="element-17596" data-mp="3po3s5a7nju0y">
            <div data-id="element-17597" data-mp="3fr7j93dud5vv">
              <p className={`font-medium ${dk.textPrimary}`} data-id="element-17598" data-mp="3fsse6u42iqu9">{result.title}</p>
              <p className={`text-sm ${dk.textSecondary}`} data-id="element-17599" data-mp="191axutg1ueeu">
                by {result.author}
              </p>
              <p className={`text-xs mt-1 font-mono text-purple-600 dark:text-purple-400`} data-id="element-17600" data-mp="1dzcktpglixvl">
                ASIN: {result.asin}
              </p>
            </div>
          </div>

          <div className="flex justify-end" data-id="element-17601" data-mp="362owa7bzg5q8">
            <button onClick={handleAddToQueue} className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors" data-id="element-17602" data-mp="312u7c9brpq7t">
              Add to Queue
            </button>
          </div>
        </div>}
    </div>;
};